export default function Footer({ onNavigate }) {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-[#E2DBCB]/10 px-6 sm:px-12 lg:px-20"
    >
      <div className="max-w-7xl mx-auto py-16 grid md:grid-cols-3 gap-12">
        <div>
          <p className="font-serif text-2xl text-[#F7F5F0]">
            Tarantina <span className="italic text-[#C5A059]">Kimono</span>
          </p>
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-[#75726B]">
            Kimonos, peignoirs, capes et tabliers d'exception pour les salons
            de coiffure. Façonnés à la main en France.
          </p>
        </div>
        <div>
          <p className="text-[10px] font-mono uppercase tracking-[0.25em] text-[#C5A059]">
            Navigation
          </p>
          <div className="mt-5 flex flex-col gap-3">
            {[
              ["Collection", "#collection"],
              ["Manifeste", "#manifeste"],
              ["Atelier", "#atelier"],
              ["Broderies", "#broderies"],
              ["Contact", "#contact"],
            ].map(([label, hash]) => (
              <button
                key={hash}
                data-testid={`footer-link-${label.toLowerCase().replace("é", "e")}`}
                onClick={() => onNavigate(hash)}
                className="w-fit text-sm text-[#B0ABA0] transition-colors hover:text-[#D4AF37]"
              >
                {label}
              </button>
            ))}
          </div>
        </div>
        <div>
          <p className="text-[10px] font-mono uppercase tracking-[0.25em] text-[#C5A059]">
            La Maison
          </p>
          <a
            href="mailto:contact@tarantina.fr"
            data-testid="footer-email"
            className="mt-5 block w-fit font-mono text-sm text-[#B0ABA0] transition-colors hover:text-[#D4AF37]"
          >
            contact@tarantina.fr
          </a>
          <a
            href="tel:+33671190938"
            data-testid="footer-phone"
            className="mt-2 block w-fit font-mono text-sm text-[#B0ABA0] transition-colors hover:text-[#D4AF37]"
          >
            06 71 19 09 38
          </a>
          <div className="mt-2 flex gap-5">
            <a
              href="https://wa.me/33671190938"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-whatsapp"
              className="font-mono text-xs text-[#75726B] transition-colors hover:text-[#D4AF37]"
            >
              WhatsApp
            </a>
            <a
              href="sms:+33671190938"
              data-testid="footer-sms"
              className="font-mono text-xs text-[#75726B] transition-colors hover:text-[#D4AF37]"
            >
              SMS
            </a>
          </div>
          <p className="mt-2 text-sm text-[#75726B]">
            Atelier Optimess — 26800 Portes-lès-Valence
          </p>
          <a
            href="https://www.threads.com/@tarantina.studio"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-threads"
            className="mt-3 block w-fit font-mono text-sm text-[#B0ABA0] transition-colors hover:text-[#D4AF37]"
          >
            @tarantina.studio — Threads
          </a>
        </div>
      </div>
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 border-t border-[#E2DBCB]/10 py-6">
        <p className="text-xs font-mono text-[#75726B]">
          © 2026 Tarantina Kimono — Maison de confection française
        </p>
        <p className="text-xs font-mono uppercase tracking-[0.2em] text-[#75726B]">
          Tarifs nets — franchise de TVA (SASU)
        </p>
        <a
          href="/admin"
          data-testid="footer-admin-link"
          className="text-xs font-mono text-[#75726B] transition-colors hover:text-[#D4AF37]"
        >
          Espace pro
        </a>
      </div>
    </footer>
  );
}
